import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import { passwordPatternValidator } from '@shared/core/validators/password-patterns.shared.validator';
import * as Tokens from '@shared/core/tokens';

import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-form-for-partial-member-password',
    templateUrl: './form-for-partial-member-password.shared.component.html',
    styleUrls: ['./form-for-partial-member-password.shared.component.scss']
})
export class FormForPartialMemberPasswordComponent extends FormTypesComponent implements OnInit, OnDestroy {
    @Input() public memberId: number;

    public error$: Observable<{ [key: string]: any; }>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
    ) {
        super(config, formBuilder);
        this.formName = 'partial-member-password';
    }

    ngOnInit(): void {
        this.formControl = this.formBuilder.group({
            password: [
                {
                    value: '',
                    disabled: false
                },
                [
                    Validators.required,
                    passwordPatternValidator(this.config.passwordRules),
                ]
            ],
            receivePromo: [
                { value: true, disabled: false }
            ]
        });

        this.loading$ = this.controllers.members.partialMemberSignUpStatus$();
        this.error$ = this.controllers.members.signUpPartialMemberError$();
    }

    ngOnDestroy(): void {
        this.controllers.members.partialMemberInitFlowReset();
    }

    public handleFormSubmit($event: Event): void {
        const formValues = this.getFormValues();

        this.controllers.members.signUpPartialMember(this.memberId, {
            ReceivePromoAllowed: formValues.receivePromo,
            Password: formValues.password,
            MemberGroupId: this.config.defaultMemberGroupId,
        });
    }

    public handleTermsClick($event: Event): void {
        console.log('OPEN UP TERMS AND CONDITIONS');
    }
}
